var _circle, _ellipse, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgEqualizeWorktime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.2788,
    cy: 32,
    r: 32,
    fill: "#F0F3F9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.2788,
    cy: 31.4927,
    rx: 18,
    ry: 18.2857,
    fill: "#D8DDEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.28 23.3672V31.7554L37.7788 37.5894",
    stroke: "#F0F3F9",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.5107,
    y: 15.4922,
    width: 1.54286,
    height: 3.00587,
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5107,
    y: 44.4844,
    width: 1.54286,
    height: 3.00587,
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0312,
    y: 30.7422,
    width: 1.50294,
    height: 3.08571,
    transform: "rotate(90 48.0312 30.7422)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.50294,
    height: 3.08571,
    transform: "matrix(4.41713e-08 1 1 -4.32562e-08 16.52 30.7422)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(0.716313 0.697779 -0.716313 0.697779 43.4175 20.0039)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(-0.716313 0.697779 0.716313 0.697779 21.1328 20.0039)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(-0.716313 0.697779 0.716313 0.697779 41.7842 40.6875)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52303,
    height: 3.04605,
    transform: "matrix(0.716313 0.697779 -0.716313 0.697779 22.7676 40.6875)",
    fill: "#F0F3F9",
    stroke: "#F0F3F9",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEqualizeWorktime);
export default __webpack_public_path__ + "static/media/img_equalize_worktime.a50eec9cceb3bc5de8c81a97a54b9c98.svg";
export { ForwardRef as ReactComponent };